import install from './install'

const deferred = {}
deferred.promise = new Promise((resolve, reject) => {
  deferred.resolve = resolve
  deferred.reject = reject
})

export default {
  install
}



// WEBPACK FOOTER //
// ./src/apis/sa-api/index.js